@if (alertInfo.show) {
  <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
    {{ alertInfo.message }}
  </ngb-alert>
}
<form [formGroup]="form">
  <div class="row g-3">
    <div class="col-sm-6 mt-2">
      <select-field [selectFormControl]="getLawJurisdictionsSelect()" [options]="jurisdictionsOptions"
        label="Jurisdictions"/>
    </div>
    <div class="col-sm-6 mt-2">
      <input-field type="text" [inputFormControl]="getLawNameInput()" label="Name" placeholder="Name" />
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6 mt-2">
      <input-field type="date" [inputFormControl]="getLawStartDateInput()" label="Validity start date" placeholder="Validity start date" />
    </div>
    <div class="col-sm-6 mt-2">
      <input-field type="date" [inputFormControl]="getLawEndDateInput()" label="Validity end date" placeholder="Validity end date" />
    </div>


  </div>

  <div class="text-center mt-4">
    <button type="button" class="btn btn-success px-4 py-2" (click)="submitForm()">
      Save
    </button>
  </div>
</form>